module.exports = __webpack_public_path__ + "f9174cd1cd3240b0a15ae883092c7f5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1_variable/public/news/img1_1.jpg
// module id = 440
// module chunks = 0